// extracted by mini-css-extract-plugin
module.exports = {"ranking":"ranking_ranking__cuDkZ","ranking-item":"ranking_ranking-item__oMRxv","rank":"ranking_rank__MGiOC","rank-description":"ranking_rank-description__2F1V6"};